import * as types from './mutation-types'

const SET_SEEDERS = async ({commit}, obj) => {
  const seeders = (await axios.get(`${process.env.API_PATH}/resposta`)).data
  commit(types.SET_SEEDERS, {seeders})
  commit(types.SET_SHOULD_RELOAD, {state: false})
}

const updateRespostas = async ({commit}, obj) => {
  const {data} = await axios.post(`${process.env.API_PATH}/resposta`, {respostas: obj.respostas})
   commit(types.SET_SHOULD_RELOAD, {state: true})
}
const shouldReload =  ({commit}) => {
  commit(types.SET_SHOULD_RELOAD, {state: true})
}

const setList = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/user/seeder/list`)
  commit(types.SET_LIST, {list: data})
  commit(types.SET_SHOULD_RELOAD, {state: false})
}

export default {
  SET_SEEDERS, setList, updateRespostas,shouldReload
}



// WEBPACK FOOTER //
// ./src/features/Seeder/store/actions.js